var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcImages = function SvgIcImages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3641",
    fillRule: "evenodd",
    d: "M12,0 C13.1045695,0 14,0.8954305 14,2 L14,10 C14,11.1045695 13.1045695,12 12,12 L2,12 C0.8954305,12 0,11.1045695 0,10 L0,2 C0,0.8954305 0.8954305,0 2,0 L12,0 Z M12,1 L2,1 C1.48716416,1 1.06449284,1.38604019 1.00672773,1.88337887 L1,2 L1,10 C1,10.5128358 1.38604019,10.9355072 1.88337887,10.9932723 L2,11 L12,11 C12.5128358,11 12.9355072,10.6139598 12.9932723,10.1166211 L13,10 L13,2 C13,1.48716416 12.6139598,1.06449284 12.1166211,1.00672773 L12,1 Z M12,2 L12,10 L2,10 L2,9 L6,5 L8,6 L12,2 Z M3.5,2 C4.32842712,2 5,2.67157288 5,3.5 C5,4.32842712 4.32842712,5 3.5,5 C2.67157288,5 2,4.32842712 2,3.5 C2,2.67157288 2.67157288,2 3.5,2 Z"
  })));
};
export default SvgIcImages;